import * as React from 'react';
export const gridViewSvg = React.forwardRef(function gridViewSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 1.5A1.5 1.5 0 0 1 1.5 0h2.25a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5H1.5A1.5 1.5 0 0 1 0 3.75V1.5Zm1.5-.2h2.25c.11 0 .2.09.2.2v2.25a.2.2 0 0 1-.2.2H1.5a.2.2 0 0 1-.2-.2V1.5c0-.11.09-.2.2-.2ZM0 8.25a1.5 1.5 0 0 1 1.5-1.5h2.25a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5H1.5A1.5 1.5 0 0 1 0 10.5V8.25Zm1.5-.2h2.25c.11 0 .2.09.2.2v2.25a.2.2 0 0 1-.2.2H1.5a.2.2 0 0 1-.2-.2V8.25c0-.11.09-.2.2-.2ZM8.25 0a1.5 1.5 0 0 0-1.5 1.5v2.25a1.5 1.5 0 0 0 1.5 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5V1.5A1.5 1.5 0 0 0 10.5 0H8.25Zm2.25 1.3H8.25a.2.2 0 0 0-.2.2v2.25c0 .11.09.2.2.2h2.25a.2.2 0 0 0 .2-.2V1.5a.2.2 0 0 0-.2-.2ZM6.75 8.25a1.5 1.5 0 0 1 1.5-1.5h2.25a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5H8.25a1.5 1.5 0 0 1-1.5-1.5V8.25Zm1.5-.2h2.25c.11 0 .2.09.2.2v2.25a.2.2 0 0 1-.2.2H8.25a.2.2 0 0 1-.2-.2V8.25c0-.11.09-.2.2-.2Z',
      clipRule: 'evenodd',
    }),
  );
});
gridViewSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gridView = {
  category: 'icon',
  colorable: true,
  name: 'gridView',
  svg: gridViewSvg,
};
